import { AuthService } from "shared/mechanics/auth";
import { catchErrors, skipForDevelopment, skipForPrerender } from "shared/mechanics/decorators";
import { IPlugin } from "shared/mechanics/plugin";

import { ChatbroLoader } from './external-code';

export interface IChatBroPlugin extends IPlugin {
}

export class ChatBroPlugin implements IChatBroPlugin {
	name: string = 'ChatBro';

	@catchErrors
	@skipForPrerender
	@skipForDevelopment
	init(): void {
		const currentUser = AuthService.resolveUserInfo();

		const chatBroOptions: any = { encodedChatId: process.env.REACT_APP_INTEGRATION_CHATBRO_CHATID };
		if (currentUser) {
			chatBroOptions.siteDomain = window.location.host;
			chatBroOptions.siteUserExternalId = currentUser.id;
			chatBroOptions.siteUserFullName = currentUser.displayName;
		}

		ChatbroLoader(chatBroOptions, true)
	}
}